<template>
    <div id="loan-status-dates">
        <div class="vx-row">
            <div class="vx-col w-full">
                <vx-card>
                    <h6 class="bold success">
                        ESTADO Y FECHAS DEL PROYECTO
                    </h6>
                    <div class="vx-row">
                        <div class="vx-col sm:w-full md:w-1/2">
                            <vs-list>
                                <vs-list-item title="Estado">
                                    <vs-chip
                                    size="large"
                                        color="success">
                                        {{ source.status_named }}
                                    </vs-chip>
                                </vs-list-item>
                                <vs-list-item title="Creación">{{ humanizedCompactDate(source.created_at) }}</vs-list-item>
                                <vs-list-item title="A revisión">{{ humanizedCompactDate(source.review_date) }}</vs-list-item>
                                <vs-list-item title="Pre-aprobación">{{ humanizedCompactDate(source.preapproved) }}</vs-list-item>
                                <vs-list-item title="Solicitud de asignación de proveedor">{{ humanizedCompactDate(source.supplier_assignment_request_timestamp) }}</vs-list-item>
                                <vs-list-item title="Asignación de proveedor">{{ humanizedCompactDate(source.supplier_assignment_completed_timestamp) }}</vs-list-item>
                                <vs-list-item title="Solicitud sin documentos">{{ humanizedCompactDate(source.loan_review_request_timestamp) }}</vs-list-item>
                                <vs-list-item title="Envío de oferta">{{ humanizedCompactDate(source.loan_proposal_timestamp) }}</vs-list-item>
                                <vs-list-item title="Aceptación">{{ humanizedCompactDate(source.finance.credit_acceptance_date) }}</vs-list-item>
                                <vs-list-item title="Solicitud completa">{{ humanizedCompactDate(source.documentation_complete_date) }}</vs-list-item>
                                <vs-list-item title="Aprobación">{{ humanizedCompactDate(source.approved_date) }}</vs-list-item>
                            </vs-list>
                        </div>
                        <div class="vx-col sm:w-full md:w-1/2">
                            <vs-list>
                                <vs-list-item title="Publicación">{{ humanizedCompactDate(source.public_date) }}</vs-list-item>
                                <vs-list-item title="Fondeo completo">{{ humanizedCompactDate(source.fund_date) }}</vs-list-item>
                                <vs-list-item title="Contratos (Grupo 1) enviados">{{ humanizedCompactDate(source.contracts_date) }}</vs-list-item>
                                <vs-list-item title="Formalización">{{ humanizedCompactDate(source.contracts_acceptance_date) }}</vs-list-item>
                                <vs-list-item title="Contratos (Grupo 2) enviados">TODO</vs-list-item>
                                <vs-list-item title="Disposición lista">{{ humanizedCompactDate(source.credit_dispose_ready_timestamp) }}</vs-list-item>
                                <vs-list-item title="Inicio de instalación (primera dispersión)">{{ humanizedCompactDate(source.installation_date) }}</vs-list-item>
                                <vs-list-item title="Sol. verificación de evidencia">{{ humanizedCompactDate(source.evidence_verification_request_date) }}</vs-list-item>
                                <vs-list-item title="Aceptación de evidencia">{{ humanizedCompactDate(source.complete_evidence_date) }}</vs-list-item>
                                <vs-list-item title="Disposición completada">{{ humanizedCompactDate(source.delivery_date) }}</vs-list-item>

                                <vs-list-item v-if="source.rejected_date != null" title="Rechazo">{{ humanizedCompactDate(source.rejected_date) }}</vs-list-item>
                                <vs-list-item v-if="source.refund_date != null" title="Reembolso">{{ humanizedCompactDate(source.refund_date) }}</vs-list-item>
                                <vs-list-item v-if="source.resolution_date != null" title="Archivado">{{ humanizedCompactDate(source.resolution_date) }}</vs-list-item>
                            </vs-list>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import dateHelper from '@mixins/dateHelper';
    export default {
        name: "LoanStatusDates",
        mixins: [dateHelper],
        data: () => ({

        }),
        props: {
            source: Object
        }
    }
</script>

<style>
#loan-status-dates .vx-card__body {
    padding: .5rem !important;
}
</style>